/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Source_Referral_ProgramInputs */

const en_plan_source_referral_program = /** @type {(inputs: Plan_Source_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`referral program`)
};

const es_plan_source_referral_program = /** @type {(inputs: Plan_Source_Referral_ProgramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`programa de referidos`)
};

/**
* | output |
* | --- |
* | "referral program" |
*
* @param {Plan_Source_Referral_ProgramInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_source_referral_program = /** @type {((inputs?: Plan_Source_Referral_ProgramInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Source_Referral_ProgramInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_source_referral_program(inputs)
	return en_plan_source_referral_program(inputs)
});